import mutations from "./store/mutations";
import actions from "./store/actions";
import getters from "./store/getters";

/* Module */
const _module = {
    state: () => ({
        refreshQueued: true,
        type: 'guide',
        membershipRequests: {},
        membershipClubsRequests: {},
        myMemberships: {},
        event_like_in_process: 0,
        eventTransitionEnabled : true,
        stickyEvents: {
            'fun': [],
            'guide': [],
            'bang': [],
        },
        eventDates: [
            /*[
                date: "2021-01-01",         // From the response
                events_range_low: [],       // From the response
                events_range_high: [],      // From the response
                events_range_low_count: 0,  // From the response
                events_range_high_count: 0, // From the response
                page: 0,                    // Set dynamically
                loading: false              // Set dynamically
            ]*/
        ],
        page: 0,
        spots_page:1,
        spots: [],
        source: {
            bang: {
                visible: false,
                mode: 'view',
                eventId: null
            },
            spot: {
                visible: false,
                mode: 'view',
                id: null,
                eventId:null
            },
            event: {
                visible: false,
                mode: 'view',
                eventId: null
            },
        }
    }),
    actions,
    mutations,
    getters
}

export default _module
